import { Typography, Button, Menu, MenuItem, Checkbox, FormControlLabel, Tooltip } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useState, useCallback, useEffect, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
    filterButtons: {
        width: "100%",
        minWidth: "120px",
        height: "43px",
        color: "rgba(0, 0, 0, .8)!important",
        paddingRight: "30px",
        marginBottom: "10px",
        textAlign: "left",
        border: "1px solid rgb(196, 196, 196)!important",
        borderRadius: "3px",
        borderBottom: "1px solid #757575!important",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
        "&:disabled": {
            color: "rgba(0, 0, 0, .3)!important",
        }
    },
    filterButtonsIcon: {
        color: "rgba(0,0,0,.55)!important"
    },
    label: {
        width: '100%',
        position: 'relative',
        '& span:nth-of-type(2)': {
            width: '100%',
        },
    },
}));

const SingleSelect = ({
    title,
    displayText,
    options,
    disabled,
    onSelected,
    selected,
    closeOnSelect,
    toggleOnReselect = false,
    ...props
}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedOption, setSelectedOption] = useState(selected || null);

    useEffect(() => {
        if (!selected || selected == "undefined" || selected == "") {
            setSelectedOption(null);
        } else {
            setSelectedOption(selected);
        }
    }, [selected]);

    const handleMenuClose = useCallback(() => {
        setAnchorEl(null);
        if (!closeOnSelect) onSelected(selectedOption);
    }, [selectedOption, onSelected, closeOnSelect]);

    const handleMenuClick = useCallback((event) => {
        setAnchorEl(event.currentTarget);
    }, []);

    const handleOptionSelect = useCallback((optionKey) => {
        let newValue = optionKey;

        // Se a opção clicada for a mesma e toggleOnReselect for true, desmarcar
        if (toggleOnReselect && selectedOption === optionKey) {
            newValue = null;
        }

        setSelectedOption(newValue);

        if (closeOnSelect) {
            setAnchorEl(null);
            onSelected(newValue);
        }
    }, [closeOnSelect, onSelected, toggleOnReselect, selectedOption]);

    const renderDisplayText = useMemo(() => {
        return options.find(opt => opt.key == selectedOption)?.value || displayText;
    }, [selectedOption, options, displayText]);

    return (
        <>
            {title && <Typography style={{ marginBottom: "5px" }}>{title}</Typography>}

            <Button
                variant="outlined"
                onClick={handleMenuClick}
                disabled={disabled}
                className={classes.filterButtons}
                {...props}
            >
                <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {renderDisplayText}
                </span>
                <ArrowDropDownIcon className={classes.filterButtonsIcon} />
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorReference="anchorPosition"
                anchorPosition={anchorEl ? {
                    top: anchorEl.getBoundingClientRect().bottom + window.scrollY,
                    left: anchorEl.getBoundingClientRect().left + window.scrollX
                } : undefined}
                PaperProps={{
                    style: {
                        maxHeight: "300px",
                        width: anchorEl?.offsetWidth || "300px",
                    },
                }}
            >
                {Array.isArray(options) && options.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
                    .map(opt => (
                        <MenuItem 
                            dense 
                            key={opt.key} 
                            onClick={() => handleOptionSelect(opt.key)}
                            disabled={opt.disabled}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size="small"
                                        color="primary"
                                        checked={selectedOption === opt.key}
                                        disabled={opt.disabled}
                                    />
                                }
                                className={classes.label}
                                label={
                                    <Tooltip title={opt.value}>
                                        <Typography component="label"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(100% - 30px)',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                paddingTop: "12px"
                                            }}
                                        >
                                            {opt?.customValue ? opt.customValue : opt.value}
                                        </Typography>
                                    </Tooltip>
                                }
                                disabled={opt.disabled}
                            />
                        </MenuItem>
                    ))}
            </Menu>
        </>
    );
};

export default SingleSelect;